const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const handle = async (res) => {
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data?.message || 'Request failed');
  return data;
};

const qs = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  const str = search.toString();
  return str ? `?${str}` : '';
};

const auth = (token, json = false) => ({
  Authorization: `Bearer ${token}`,
  ...(json ? { 'Content-Type': 'application/json' } : {}),
});

export const list = async (token, params = {}) => {
  const res = await fetch(`${API_BASE}/api/host/reviews${qs(params)}`, {
    headers: auth(token),
    credentials: 'include',
  });
  return handle(res);
};

export const get = async (token, id) => {
  const res = await fetch(`${API_BASE}/api/host/reviews/${id}`, {
    headers: auth(token),
    credentials: 'include',
  });
  return handle(res);
};

export const respond = async (token, id, response) => {
  const res = await fetch(`${API_BASE}/api/host/reviews/${id}/respond`, {
    method: 'POST',
    headers: auth(token, true),
    credentials: 'include',
    body: JSON.stringify({ response }),
  });
  return handle(res);
};

export const report = async (token, id, reason) => {
  const res = await fetch(`${API_BASE}/api/host/reviews/${id}/report`, {
    method: 'POST',
    headers: auth(token, true),
    credentials: 'include',
    body: JSON.stringify({ reason }),
  });
  return handle(res);
};


